export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';

export const FETCH_PROJECT_REQUEST = 'FETCH_PROJECT_REQUEST';
export const FETCH_PROJECT_SUCCESS = 'FETCH_PROJECT_SUCCESS';
export const FETCH_PROJECT_FAILURE = 'FETCH_PROJECT_FAILURE';

export const UPDATE_PROJECTS_REQUEST = 'UPDATE_PROJECTS_REQUEST';
export const UPDATE_PROJECTS_SUCCESS = 'UPDATE_PROJECTS_SUCCESS';
export const UPDATE_PROJECTS_FAILURE = 'UPDATE_PROJECTS_FAILURE';

export const DELETE_PROJECTS_REQUEST = 'DELETE_PROJECTS_REQUEST';
export const DELETE_PROJECTS_SUCCESS = 'DELETE_PROJECTS_SUCCESS';
export const DELETE_PROJECTS_FAILURE = 'DELETE_PROJECTS_FAILURE';
export const RESET_PROJECT_ADDED = "RESET_PROJECT_ADDED";

export const CLEAR_PROJECT_ERRORS = 'CLEAR_PROJECT_ERRORS';
export const CLEAR_PROJECT_SUCCESS = 'CLEAR_PROJECT_SUCCESS';